var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import RcTabs, { TabPane, TabPaneProps } from './src';
import classNames from 'classnames';
import OutlinedPlus from 'acud-icon/lib/icons/OutlinedPlus';
import OutlinedCloseSmall from 'acud-icon/lib/icons/OutlinedCloseSmall';
import devWarning from '../_util/devWarning';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
export { TabPaneProps };
function Tabs(_a) {
    var { type, className, size: propSize, onEdit, hideAdd, showEdit, centered, addIcon } = _a, props = __rest(_a, ["type", "className", "size", "onEdit", "hideAdd", "showEdit", "centered", "addIcon"]);
    const { prefixCls: customizePrefixCls } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    let editable;
    if (type === 'editable-card') {
        editable = {
            onEdit: (editType, { key, event }) => {
                onEdit === null || onEdit === void 0 ? void 0 : onEdit(editType === 'add' ? event : key, editType);
            },
            removeIcon: <OutlinedCloseSmall />,
            addIcon: addIcon || <OutlinedPlus />,
            showAdd: hideAdd !== true,
            showEdit: showEdit !== false
        };
    }
    const rootPrefixCls = getPrefixCls();
    if (process.env.NODE_ENV !== "production")
        devWarning(!('onPrevClick' in props) && !('onNextClick' in props), 'Tabs', '`onPrevClick` and `onNextClick` has been removed. Please use `onTabScroll` instead.');
    return (<SizeContext.Consumer>
            {contextSize => {
            const size = propSize !== undefined ? propSize : contextSize;
            return (<RcTabs moreTransitionName={`${rootPrefixCls}-slide-up`} {...props} className={classNames({
                    [`${prefixCls}-${size}`]: size,
                    [`${prefixCls}-card`]: ['card', 'editable-card'].includes(type),
                    [`${prefixCls}-editable-card`]: type === 'editable-card',
                    [`${prefixCls}-centered`]: centered
                }, className)} editable={editable} prefixCls={prefixCls}/>);
        }}
        </SizeContext.Consumer>);
}
Tabs.TabPane = TabPane;
export default Tabs;
